module.exports = __webpack_public_path__ + "img/wechat.66006174.png";